import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

type LoyaltyEnrollmentPreference = {
  preference: boolean;
  setPreference: (preference: boolean) => void;
};

const LoyaltyEnrollmentPreferenceContext =
  createContext<LoyaltyEnrollmentPreference | null>(null);

export const LoyaltyEnrollmentPreferenceProvider = ({
  children,
  scopeKey,
}: {
  children: ReactNode;
  scopeKey: string;
}) => {
  return (
    <CheckoutPreference scopeKey={scopeKey}>{children}</CheckoutPreference>
  );
};

const CheckoutPreference = ({
  children,
  scopeKey,
}: {
  children: ReactNode;
  scopeKey: string;
}) => {
  const [scopedPreference, setScopedPreference] = useState({
    preference: true,
    scopeKey,
  });
  const preference =
    scopedPreference.scopeKey === scopeKey ? scopedPreference.preference : true;
  const setPreference = useCallback(
    (nextPreference: boolean) => {
      setScopedPreference({ preference: nextPreference, scopeKey });
    },
    [scopeKey]
  );

  useEffect(() => {
    setScopedPreference((currentPreference) =>
      currentPreference.scopeKey === scopeKey
        ? currentPreference
        : { preference: true, scopeKey }
    );
  }, [scopeKey]);

  const value = useMemo(
    () => ({ preference, setPreference }),
    [preference, setPreference]
  );
  return (
    <LoyaltyEnrollmentPreferenceContext.Provider value={value}>
      {children}
    </LoyaltyEnrollmentPreferenceContext.Provider>
  );
};

export const useLoyaltyEnrollmentPreference = () =>
  useContext(LoyaltyEnrollmentPreferenceContext);
